angular.module('bmsApp.crm.enquiry')
	.controller('EnquiryViewCtrl', [
		'$state',
		'$scope',
		'$filter',
		'ngTableParams',
		'EmailSvc',
		'ActivitySvc',
		'NoteSvc',
		'EnquirySvc',
		'ReminderSvc',
		'notify',
		'$ngBootbox',
		'$timeout',
		function ($state,
				  $scope,
				  $filter,
				  ngTableParams,
				  EmailSvc,
				  ActivitySvc,
				  NoteSvc,
				  EnquirySvc,
				  ReminderSvc,
				  notify,
				  $ngBootbox,
				  $timeout) {

			$scope.init = function () {
				var enquiryId = $state.params.enquiryId;
				$scope.loading = true;
				EnquirySvc.read(enquiryId)
					.then(function (response) {
						$scope.enquiry = response.data.enquiry;
						$scope.proformaTables = {
							mmProformaQuoteTableParams: null,
							tgProformaQuoteTableParams: null
						};
						var mmProformaQuoteParams = {
							count: $scope.enquiry.mm_proforma_quotes.length,
							sorting: {id: 'desc'}
						};
						var mmProformaQuoteOptions = {
							total: 0, // length of data
							counts: null,
							getData: function ($defer, params) {
								params.total($scope.enquiry.mm_proforma_quotes.length);
								$defer.resolve($filter('orderBy')($scope.enquiry.mm_proforma_quotes, params.orderBy()[0]));
							}
						};
						$scope.proformaTables.mmProformaQuoteTableParams = new ngTableParams(mmProformaQuoteParams, mmProformaQuoteOptions);

						var tgProformaQuoteParams = {
							count: $scope.enquiry.tg_proforma_quotes.length,
							sorting: {id: 'desc'}
						};
						var tgProformaQuoteOptions = {
							total: 0, // length of data
							counts: null,
							getData: function ($defer, params) {
								params.total($scope.enquiry.tg_proforma_quotes.length);
								$defer.resolve($filter('orderBy')($scope.enquiry.tg_proforma_quotes, params.orderBy()[0]));
							}
						};

						$scope.proformaTables.tgProformaQuoteTableParams = new ngTableParams(tgProformaQuoteParams, tgProformaQuoteOptions);
						$scope.loading = false;


					});
			};

			$scope.init();

			// Action menu links

			$scope.addActivity = function () {
				var activity = {
					enquiry: $scope.enquiry,
					isEnquiry: true,
				};
				ActivitySvc.showSaveModal(activity);
			};

			$scope.tabsActive = {
				proformaQuotes: true,
				notes: false
			};

			function setActiveTab(name) {
				angular.forEach($scope.tabsActive, function (value, key) {
					$scope.tabsActive[key] = String(key) === name;
				});
			}

			$scope.note = {
				api: {}
			};

			$scope.tabNotes = function () {
				$scope.note.api.showNotes();
			};

			$scope.addNote = function () {
				var note = {
					object_type: 'App\\Models\\Crm\\Enquiry',
					object_id: $scope.enquiry.id
				};
				NoteSvc.showSaveModal(note);
			};

			$scope.$on('notesUpdated', function () {
				setActiveTab('notes');
			});

			$scope.onMmProformaQuoteClick = function (quote) {
				$state.go('main.merrymaids.proformaQuote.read', {
					jobId: quote.id
				});
			};

			$scope.onTgProformaQuoteClick = function (quote) {
				$state.go('main.trugreen.quote.index.view', {
					quoteId: quote.id
				});
			};

			$scope.emailForm = function (emailAddress, objectType, objectId, enquiry) {
				var email = {
					to: emailAddress,
					object_type: objectType,
					object_id: objectId
				};
				EmailSvc.showSendModal(email, enquiry);
			};

			$scope.showReminderModal = function () {
				ReminderSvc.showReminderModal('App\\Models\\Crm\\Enquiry', $scope.enquiry.id);
			};

			// sm specific logic

			$scope.smConvertProformaToQuote = function () {
				if (smValidateConversion()) {
					$ngBootbox.confirm('You are about to convert this proforma into a new quote, this will subsequently convert the enquiry to a customer. Continue?')
						.then(function () {
							EnquirySvc.smConvert($scope.enquiry)
								.then(function (response) {
									notify({
										message: 'Enquiry converted and quote created'
									});
									$state.go('main.sm.quote.index.view', {quoteId: response.data.job.id});
								});
						});
				}
				else {
					$scope.smConversionFailed = true;
				}
			};

			$scope.smConvertToJob = function () {

			};

			function smValidateConversion() {
				var retValue = true;
				if (angular.isObject($scope.enquiry.sm_proforma_quote)) {
					if ($scope.enquiry.address_line_1 == "" || $scope.enquiry.city == "" || $scope.enquiry.postcode == "") {
						retValue = false;
					}
				}
				return retValue;
			}

		}
	]);
